module.exports = __webpack_public_path__ + "static/media/favicon-152.cbb6bd47.png";